import React, { Component } from "react";
import PropTypes from "prop-types";
import { Textfit } from "react-textfit";
import $ from "jquery";
import ReactPlayer from "react-player";
import { jarallax } from "jarallax";

export default class HeroBanner extends Component {
  componentDidMount() {
    if (this.props.video) {
      $(document).ready(function() {
        jarallax($(".jarallax"), {
          speed: 0.5
        });
      });
    }
  }

  render() {
    // const showFooter = true;
    const {
      backgroundImage,
      headerText,
      descText,
      custom,
      fulljustify
    } = this.props;
    if (this.props.video) {
      return (
        <div className="video-bg home-page">
          <ReactPlayer
            className="react-player"
            url={backgroundImage}
            width="auto"
            height="auto"
            loop
            playsinline
            muted
            playing
          />

          {/* {showFooter && (
            <div className="social-icons hero-social-icons container">
              <ul>
                <li>
                  <a
                    href="https://www.facebook.com/v1rage/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      className="svg"
                      style={{ display: "none" }}
                      src={fbLogo}
                      alt="Facebook logo white"
                    />
                  </a>
                </li>
                {/* <li>
                  <a
                    href="https://www.facebook.com/?ref=logo"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      className="svg"
                      style={{ display: "none" }}
                      src={ytLogo}
                      alt="Youtube logo white"
                    />
                  </a>
                </li>
                <li>
                  <a
                    href=""
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      className="svg"
                      style={{ display: "none" }}
                      src={twLogo}
                      alt="Twitter logo white"
                    />
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.instagram.com/v1ragecom/ "
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      className="svg"
                      style={{ display: "none" }}
                      src={instaLogo}
                      alt="Instagram logo white"
                    />
                  </a>
                </li>
              </ul>
            </div>
          )} */}
        </div>
      );
    } else {
      return (
        <div
          className={`hero hero--long ${
            this.props.backgroundFixed ? "background-fixed" : ""
          } ${this.props.video ? "video" : "jarallax"}`}
          style={{
            backgroundImage: this.props.video ? "" : `url(${backgroundImage})`
          }}
        >
          {descText && (
            <div className="hero-text container">
              <div className="row">
                <div className="col-12">{descText}</div>
              </div>
            </div>
          )}
          <div className="hero-header container">
            <div className="row">
              <div className="col-12">
                {!custom ? (
                  <Textfit
                    className={`text-fit ${fulljustify ? "fulljustify" : ""}`}
                    mode="single"
                    max={200}
                  >
                    {headerText}
                  </Textfit>
                ) : (
                  <p>{headerText}</p>
                )}
              </div>
            </div>
          </div>
        </div>
      );
    }
  }
}

HeroBanner.propTypes = {
  backgroundImage: PropTypes.string.isRequired,
  headerText: PropTypes.string,
  descText: PropTypes.object,
  custom: PropTypes.bool,
  fulljustify: PropTypes.bool,
  video: PropTypes.bool
};

HeroBanner.defaultProps = {
  showFooter: true,
  custom: false,
  fulljustify: false,
  video: false
};
